import React, { useCallback } from "react";
import { Row, Col, Select, Input } from "antd";
import { STATUS_OPTIONS } from "../constant";
import { useRequisitionBranchContext } from "../context";
import SelectTeamName from "../../reports/components/SelectTeamName";
const { Search } = Input;

const SearchComponent = () => {
  const { state, dispatch, fetchData, handleFilterChange } =
    useRequisitionBranchContext();
  const onChange = useCallback(
    (payload) => {
      const filters = {
        ...state.filters,
        ...payload,
        offset: 0,
      };

      dispatch({
        type: "SET_FILTERS",
        payload: { ...payload, offset: 0 },
      });

      if (Object.values(payload).some((value) => value === "")) {
        fetchData(filters);
      }
    },
    [state.filters, dispatch, fetchData],
  );
  const onSearch = useCallback(() => {
    fetchData(state.filters);
  }, [fetchData, state.filters]);

  return (
    <Row gutter={16}>
      <Col span={5}>
        <Select
          value={state.filters.status}
          onChange={(value) => handleFilterChange({ status: value })}
          placeholder="เลือกสถานะ"
          style={{ width: "100%" }}
        >
          {STATUS_OPTIONS.map((item) => (
            <Select.Option key={item.value} value={item.value}>
              {item.label}
            </Select.Option>
          ))}
        </Select>
      </Col>

      <Col span={5}>
        <SelectTeamName
          value={state.filters.teamName}
          onChange={(value) => handleFilterChange({ teamName: value || "" })}
          withAll
        />
      </Col>

      <Col span={4}>
        <Search
          placeholder="รหัสนักธุรกิจ (เจ้าของ)"
          allowClear
          value={state.filters.ownerPartnerCode}
          onChange={(event) =>
            onChange({ ownerPartnerCode: event.target.value })
          }
          onSearch={onSearch}
        />
      </Col>

      <Col span={4}>
        <Search
          placeholder="ชื่อเจ้าของ"
          allowClear
          value={state.filters.ownerName}
          onChange={(event) => onChange({ ownerName: event.target.value })}
          onSearch={onSearch}
        />
      </Col>

      <Col span={5}>
        <Search
          placeholder="ชื่อ นามสกุล, เบอร์โทร, อีเมล ผู้ใช้โค้ด"
          allowClear
          value={state.filters.userSearch}
          onChange={(event) => onChange({ userSearch: event.target.value })}
          onSearch={onSearch}
        />
      </Col>
    </Row>
  );
};

export default SearchComponent;
